<template>
  <span class="ui-check" :class="[disabled ? 'disabled' : '', size]"
        @click="check = !check">
    <icon :src="iconSrc" class="ui-check__icon"></icon>
  </span>
</template>

<script>
import selected from '@/assets/images/icon/checkbox_selected.png';
import selectedDisable from '@/assets/images/icon/checkbox_selected_disable.png';
import unselected from '@/assets/images/icon/checkbox_unselected.png';
import unselectedDisable from '@/assets/images/icon/checkbox_unselected_disabled.png';
import Icon from './Icon';

export default {
  name: 'NioCheck',
  model: {
    prop: 'checked',
    event: 'input'
  },
  components: {
    Icon
  },
  props: {
    checked: {
      type: Boolean,
      default: false
    },
    disabled: {
      type: Boolean,
      default: false
    },
    size: {
      type: String,
      default: ''
    }
  },
  data(){
    return {
      check: this.checked
    };
  },
  computed: {
    iconSrc(){
      if (this.check){
        return this.disabled ? selectedDisable : selected;
      }
      return this.disabled ? unselectedDisable : unselected;

    }
  },
  watch: {
    check(newVal){
      this.$emit('input', newVal);
    }
  }
};
</script>

<style lang="scss" scoped>
@import "../../assets/scss/standard";

.ui-check {
  padding: sizeTrans($space_10);

  &.disabled {
    pointer-events: none;
  }

  &__icon {
    width: sizeTrans(16);
    height: sizeTrans(16);
  }

  &.large {
    .ui-check__icon {
      width: sizeTrans(20);
      height: sizeTrans(20);
    }
  }
}
</style>